import { useMessageToState } from "./useMessageToState";

const getProduct = (editor: eXpress.core.IEditor) => editor.definition?.product;

export const useProduct = () => {
	const product = useMessageToState({
		name: "useProduct",
		filterMessage: eXpress.core.isProductChanged,
		getState: getProduct,
	});

	return product;
};
